import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/hooks';
import { orders } from '../../redux/orders/action';
import { selectOrdersPrintItem } from '../../redux/orders/selector';
import { useSelector } from 'react-redux';
import PageLoader from '../../components/PageLoader';
import { format } from '../services/date.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


const InvoiceBill = ({

}: any) => {
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const orderInvoiceData = useSelector(selectOrdersPrintItem)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        orderInvoice,
        setOrderInvoice
    ] = useState<any>({})

    const invoiceData: any = {
        orderId: orderInvoice?.OrderDetail?.OrderId,
        companyName: orderInvoice?.BusinessDetail?.Name,
        companyAddress: `${orderInvoice?.BusinessDetail?.Address?.building},${orderInvoice?.BusinessDetail?.Address?.locality},${orderInvoice?.BusinessDetail?.Address?.city},${orderInvoice?.BusinessDetail?.Address?.state}-${orderInvoice?.BusinessDetail?.Address?.area_code},${orderInvoice?.BusinessDetail?.Address?.country}`,
        contactInfo: `Phone: ${orderInvoice?.BusinessDetail?.PhoneNumber} | Email: ${orderInvoice?.BusinessDetail?.EmailId}`,
        customerInfo: `Phone: ${orderInvoice?.CustomerDetail?.PhoneNumber} | Email: ${orderInvoice?.CustomerDetail?.EmailId}`,
        invoiceNumber: orderInvoice?.BillingDetail?.InvoiceNumber,
        date: format(orderInvoice?.BillingDetail?.InvoiceDate),
        customerName: orderInvoice?.CustomerDetail?.Name,
        customerAddress: `${orderInvoice?.CustomerDetail?.Address?.building},${orderInvoice?.CustomerDetail?.Address?.locality}`,
        cityStateZip: `${orderInvoice?.CustomerDetail?.Address?.city},${orderInvoice?.CustomerDetail?.Address?.state}-${orderInvoice?.CustomerDetail?.Address?.area_code},${orderInvoice?.CustomerDetail?.Address?.country}`,
        items: orderInvoice?.OrderDetail?.order_items,
        tax: 0,
        paymentInstructions: `Account: ${orderInvoice?.PaymentDetail?.BankAccountNumber} | IFSC_Code:${orderInvoice?.PaymentDetail?.IFSC_Code}`
    };
    // const subtotal = invoiceData?.items.reduce((sum: any, item: any) => sum + item.quantity * item.DeliveryCharge, 0);
    // const total = subtotal + invoiceData?.tax;

    const fetchOrderInvoiceById = async () => {
        await setIsLoading(true)
        await dispatch(orders.resetAction({ actionType: 'print' }))
        await dispatch(orders.print({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/invoice`, entity: 'orders', jsonData: {


                Records: [
                    {
                        context: {},
                        Message: {
                            InvoiceNumber: parmas?.id
                        }
                    }
                ]

            }
        }))

        await setIsQuery(true)
        await setIsLoading(false)


    }
    const fetchDataOrder = async () => {
        await setOrderInvoice(orderInvoiceData?.result?.items?.Message)

    }

    useEffect(() => {
        if (!isQuery) {
            fetchOrderInvoiceById()
        } else if (isQuery && orderInvoiceData?.isSuccess) {
            fetchDataOrder()
        }

    }, [isQuery]);
    return (<>
        {isLoading ? <PageLoader /> :
            <>
                <div

                    className="p-6 mb-20 max-w-4xl mx-auto bg-white border border-gray-200 shadow-md rounded-lg">
                    <header
                        className="mb-6 text-center">
                        <h1 className="text-2xl font-bold mb-2">{invoiceData?.companyName}</h1>
                        <p className="text-gray-600">{invoiceData?.companyAddress}</p>
                        <p className="text-gray-600">{invoiceData?.contactInfo}</p>
                    </header>

                    <section className="mb-6">
                        <div className="flex justify-between">
                            <div>
                                <p className="font-bold">Invoice Number:</p>
                                <p>{invoiceData?.invoiceNumber}</p>
                            </div>

                            <div>
                                <p className="font-bold">Date:</p>
                                <p>{invoiceData?.date}</p>
                            </div>
                        </div>
                    </section>
                    <section className="mb-6">
                        <div>
                            <p className="font-bold">Order Id:</p>
                            <p>{invoiceData?.orderId}</p>
                        </div>
                    </section>
                    <section className="mb-6">
                        <h2 className="text-lg font-bold">Bill To:</h2>
                        <p>{invoiceData?.customerName}</p>
                        <p>{invoiceData?.customerAddress}</p>
                        <p>{invoiceData?.cityStateZip}</p>
                        <p>{invoiceData?.customerInfo}</p>
                    </section>

                    <section className="mb-6">
                        <div className="w-full border-x border-y border-slate-800">
                            <div className="grid grid-cols-4 bg-gray-100  border-x border-y border-slate-800">
                                <div className=" p-1  min-w-24  text-left">Name</div>
                                <div className="  p-1  text-right">Qty</div>
                                <div className="  p-1  text-right">Weight</div>
                            </div>
                            {invoiceData?.items?.map((item: any, index: any) => (
                                <div key={index} className='grid grid-cols-4 border-x border-b border-slate-800'>
                                    <div className="border-b border-slate-800 min-w-24 p-1">{item.Category}</div>
                                    <div className="border-b border-slate-800 p-1 text-right">{item.quantity}</div>
                                    <div className=" border-b border-slate-800 p-1 text-right">{item.weight}</div>

                                </div>
                            ))}
                        </div>
                    </section >

                    <section className="mb-6 text-right">
                        <p className="text-lg font-bold">Subtotal: ₹{orderInvoice?.OrderDetail?.DeliveryCharge.toFixed(2)}</p>
                        <p className="text-lg font-bold">Waiting Charge: ₹{orderInvoice?.OrderDetail?.WaitingCharge ? orderInvoice?.OrderDetail?.WaitingCharge.toFixed(2) : 0.00} </p>
                        <p className="text-lg font-bold">Tax: ₹{invoiceData?.tax.toFixed(2)}</p>
                        <p className="text-xl font-bold">Total Amount: ₹{orderInvoice?.OrderDetail?.TotalAmount.toFixed(2)}</p>
                    </section>

                    <footer className="border-t border-gray-300 pt-4">
                        <h2 className="text-lg font-bold mb-2">Payment Instructions</h2>
                        <p>{invoiceData?.paymentInstructions}</p>
                    </footer>
                </div >
                <div
                    id="pdf-content"
                    className="absolute left-[-9999px] top-0 p-6 max-w-4xl mx-auto bg-white border border-gray-200 shadow-md rounded-lg">
                    <header
                        className="mb-6 text-center">
                        <h1 className="text-2xl font-bold mb-2">{invoiceData?.companyName}</h1>
                        <p className="text-gray-600">{invoiceData?.companyAddress}</p>
                        <p className="text-gray-600">{invoiceData?.contactInfo}</p>
                    </header>

                    <section className="mb-6">
                        <div className="flex justify-between">
                            <div>
                                <p className="font-bold">Invoice Number:</p>
                                <p>{invoiceData?.invoiceNumber}</p>
                            </div>
                            <div>
                                <p className="font-bold">Date:</p>
                                <p>{invoiceData?.date}</p>
                            </div>
                        </div>
                    </section>
                    <section className="mb-6">
                        <div>
                            <p className="font-bold">Order Id:</p>
                            <p>{invoiceData?.orderId}</p>
                        </div>
                    </section>
                    <section className="mb-6">
                        <h2 className="text-lg font-bold">Bill To:</h2>
                        <p>{invoiceData?.customerName}</p>
                        <p>{invoiceData?.customerAddress}</p>
                        <p>{invoiceData?.cityStateZip}</p>
                    </section>

                    <section className="mb-6">
                        <div className="w-full border-x border-y border-slate-800">
                            <div className="grid grid-cols-4 bg-gray-100  border-x border-y border-slate-800">
                                <div className=" p-1  min-w-24  text-left">Name</div>
                                <div className="  p-1  text-right">Qty</div>
                                <div className="p-1  text-right">Weight</div>
                                {/* <div className="  p-1 text-right">Amount</div> */}
                            </div>
                            {invoiceData?.items?.map((item: any, index: any) => (
                                <div key={index} className='grid grid-cols-4 border-x border-b border-slate-800'>
                                    <div className="border-b border-slate-800 min-w-24 p-1">{item.Category}</div>
                                    <div className="border-b border-slate-800 p-1 text-right">{item.quantity}</div>
                                    <div className="border-b border-slate-800 p-1 text-right">{item.weight}</div>
                                </div>
                            ))}
                        </div>
                    </section >

                    <section className="mb-6 text-right">
                        <p className="text-lg font-bold">Subtotal: ₹{orderInvoice?.OrderDetail?.DeliveryCharge.toFixed(2)}</p>
                        <p className="text-lg font-bold">Waiting Charge: ₹{orderInvoice?.OrderDetail?.WaitingCharge ? orderInvoice?.OrderDetail?.WaitingCharge.toFixed(2) : 0.00} </p>
                        <p className="text-lg font-bold">Tax: ₹{invoiceData?.tax.toFixed(2)}</p>
                        <p className="text-xl font-bold">Total Amount: ₹{orderInvoice?.OrderDetail?.TotalAmount.toFixed(2)}</p>
                    </section>

                    <footer className="mt-6 border-t border-gray-300 pt-4">
                        <h2 className="text-lg font-bold mb-2">Payment Instructions</h2>
                        <p>{invoiceData?.paymentInstructions}</p>
                    </footer>
                </div > </>}
    </>


    );
};

const PDFGenerator = async () => {
    const element = document.getElementById("pdf-content");
    if (!element) return;


    const canvas = await html2canvas(element, {
        scale: 2, scrollY: 0,
        width: 900,
        height: 1200
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("invoice.pdf");
}

const MobileInvoice = () => {


    return <div className="p-4" >
        <button
            onClick={() => PDFGenerator()}
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
        >
            Download PDF
        </button>
        <div className='pt-2'>
            <InvoiceBill />
        </div>

    </div>;
}
export default MobileInvoice;
